import {
  useState,
  // useState,
} from "react";
import {
  Box,
  Button,
  CircularProgress,
  Drawer,
  ListItemText,
  Menu,
  MenuItem,
  Typography,
} from "@mui/material";

import {
  HeaderLeftContent,
  HeaderRightContent,
  StyledHeader,
} from "../Common/styles/header";
import AddRecordModal from "./Modals/AddRecordModal";
// import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
// import { DownloadIcon } from "../Common/assets/Icons";
// import ImportParticipantsModal from "./Modals/ImportParticipantsModal";
import SendMultipleConsentDrawer from "./Modals/SendMultipleConsentDrawer";
import NoAccessModal from "./Modals/NoAccessModal";
import SendScreenerModal from "./Modals/SendScreenerModal";
import { KeyboardArrowDown } from "@mui/icons-material";
import { useAppDispatch, useAppSelector } from "../../Redux/hooks";
import { clearParticipantIds } from "../../Redux/reducers/participantsSlice";
import ExportAllModal from "../StudyDesigner/ExportAllModal";
import { errorToastMessage, toastMessage } from "../../utils/toast";
import http from "../../utils/http";
import { AxiosResponse } from "axios";
import { useParams } from "react-router-dom";

type Props = {
  addUser: boolean;
};

const RecordsHeader = ({ addUser }: Props) => {
  // const [loader] = useState(false);
  const dispatch = useAppDispatch();
  const { id: studyId } = useParams();
  const [showModal, setShowModal] = useState(false);
  // const [showImportModal, setShowImportModal] = useState(false);
  const [submitLoader, setSubmitLoader] = useState(false);
  const [showConsentDrawer, setShowConsentDrawer] = useState("");
  const [showExportModal, setShowExportModal] = useState(false);
  const [showNoAccessModal, setShowNoAccessModal] = useState(false);
  const [showSendScreenerModal, setShowSendScreenerModal] = useState(false);
  const selectedParticipantIds = useAppSelector(
    (state) => state.participants.selectedParticipantIds
  );
  const accessibleParticipants = useAppSelector(
    (state) => state.participants.accessibleParticipants
  );
  const [exportLoader, setExportLoader] = useState(false);

  const [anchorEl, setAnchorEl] = useState<any>(null);
  const open = Boolean(anchorEl);

  const dataEditable = useAppSelector((state) => state.study.dataEditable);

  const siteIds = useAppSelector((state) => state.participants.siteIds);
  const status = useAppSelector((state) => state.participants.status);
  const isLocked = useAppSelector((state) => state.participants.isLocked);
  const screenerCompleted = useAppSelector(
    (state) => state.participants.screenerCompleted
  );
  const screenerReceived = useAppSelector(
    (state) => state.participants.screenerReceived
  );
  const screenerCompletedFrom = useAppSelector(
    (state) => state.participants.screenerCompletedFrom
  );
  const screenerCompletedTo = useAppSelector(
    (state) => state.participants.screenerCompletedTo
  );
  const cohortId = useAppSelector((state) => state.participants.cohortId);
  const customHeaderValues = useAppSelector(
    (state) => state.participants.customHeaderValues
  );
  const searchField = useAppSelector(
    (state) => state.participants.searchField
  );
  const searchQuery = useAppSelector(
    (state) => state.participants.searchQuery
  );
  const notesQuery = useAppSelector(
    (state) => state.participants.notesQuery
  );

  const closeModal = () => {
    setShowModal(false);
  };

  // const closeImportModal = () => {
  //   setShowImportModal(false);
  // };

  const openConsentDrawer = (formType: "consent" | "sunshine") => {
    if (accessibleParticipants.length === 0) {
      setShowNoAccessModal(true);
      return;
    }
    setShowConsentDrawer(formType);
  };

  const closeConsentDrawer = () => {
    setShowConsentDrawer("");
  };

  const handleClearAll = () => {
    dispatch(clearParticipantIds());
  };
  const closeExportModal = () => {
    setShowExportModal(false);
  };

  const closeSendScreenerModal = () => {
    setShowSendScreenerModal(false);
  };

  const handleSnowballEmail = async () => {
    try {
      setSubmitLoader(true);
      let res: AxiosResponse = await http.post(
        `/participants/snowball-recruitment`,
        {
          studyId,
        }
      );
      toastMessage("success", res?.data?.message);
      closeModal();
      setSubmitLoader(false);
    } catch (err) {
      setSubmitLoader(false);
      errorToastMessage(err as Error);
    }
  };

  const handleExport = async () => {
    try {
      setExportLoader(true);
      let httpUrl = `/participants/export?studyId=${studyId}`;

      if (siteIds && siteIds.length > 0) {
        httpUrl += `&sitesIds=${siteIds.join(",")}`;
      }
      if (status) {
        httpUrl += `&eligibilityStatus=${status}`;
      }
      if (isLocked) {
        httpUrl += `&isLocked=${isLocked === "yes"}`;
      }
      if (screenerCompleted) {
        httpUrl += `&hasCompletedScreener=${screenerCompleted === "yes"}`;
      }
      if (screenerReceived) {
        httpUrl += `&hasReceivedScreener=${screenerReceived === "yes"}`;
      }
      if (screenerCompletedFrom) {
        httpUrl += `&screenerCompletedFrom=${encodeURIComponent(screenerCompletedFrom)}`;
      }
      if (screenerCompletedTo) {
        httpUrl += `&screenerCompletedTo=${encodeURIComponent(screenerCompletedTo)}`;
      }
      if (cohortId) {
        httpUrl += `&participantGroupId=${cohortId}`;
      }
      if (customHeaderValues && customHeaderValues.length > 0) {
        const customFields: Record<string, string | string[]> = {};
        customHeaderValues.forEach((field) => {
          customFields[field.key] = field.value;
        });
        httpUrl += `&customColumns=${encodeURIComponent(JSON.stringify(customFields))}`;
      }
      if (searchField && searchQuery) {
        httpUrl += `&searchField=${encodeURIComponent(searchField)}&searchQuery=${encodeURIComponent(searchQuery)}`;
      }
      if (notesQuery) {
        httpUrl += `&notesQuery=${encodeURIComponent(notesQuery)}`;
      }

      const res = await http.get(httpUrl, {
        responseType: "blob",
      });
      const url = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement("a");
      link.href = url;
      link.download = `study-participants-${new Date().getTime()}.csv`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (err: any) {
      try {
        const text = await err.response.data.text();
        const errorData = JSON.parse(text);
        errorToastMessage(errorData || "Export failed");
      } catch (e) {
        errorToastMessage(err as Error);
      }
    } finally {
      setExportLoader(false);
    }
  };

  return (
    <StyledHeader sx={{ borderBottom: "1px solid #E5E7EB" }}>
      <Box sx={HeaderLeftContent}>
        <Typography variant="h2" color="text.primary">
          Participants
        </Typography>
      </Box>

      <Box sx={HeaderRightContent}>
        {/* <Button
          variant="outlined"
          startIcon={<DownloadIcon />}
          onClick={() => setShowImportModal(true)}
        >
          Import Participants
        </Button> */}
        {/* {addUser && (
          <Button
            variant="contained"
            startIcon={
              <PersonOutlineOutlinedIcon
                sx={{ height: "24px", width: "24px" }}
              />
            }
            onClick={() => setShowModal(true)}
          >
            Add New
          </Button>
        )} */}
        {selectedParticipantIds.length > 0 && (
          <>
            <Button variant="outlined" onClick={handleClearAll}>
              Clear All
            </Button>

            {dataEditable && (
              <Button
                variant="outlined"
                endIcon={<KeyboardArrowDown />}
                onClick={(e) => setAnchorEl(e?.currentTarget)}
              >
                Actions
              </Button>
            )}
          </>
        )}
        <Button
          variant="contained"
          onClick={handleSnowballEmail}
          disabled={submitLoader}
          startIcon={submitLoader ? <CircularProgress size={18} /> : null}
        >
          Send Snowball Email
        </Button>
        <Button
          variant="contained"
          onClick={handleExport}
          disabled={exportLoader}
          startIcon={exportLoader ? <CircularProgress size={18} /> : null}
        >
          Export Participant List
        </Button>
      </Box>

      {showModal && (
        <AddRecordModal showModal={showModal} closeModal={closeModal} />
      )}

      {/* {showImportModal && (
        <ImportParticipantsModal
          showImportModal={showImportModal}
          closeImportModal={closeImportModal}
        />
      )} */}
      {showConsentDrawer && (
        <Drawer
          open={!!showConsentDrawer}
          onClose={closeConsentDrawer}
          anchor={"right"}
        >
          <SendMultipleConsentDrawer
            closeDrawer={closeConsentDrawer}
            formType={showConsentDrawer as "consent" | "sunshine"}
          />
        </Drawer>
      )}
      {showNoAccessModal && (
        <NoAccessModal
          openModal={showNoAccessModal}
          closeModal={() => setShowNoAccessModal(false)}
        />
      )}
      {showExportModal && (
        <ExportAllModal
          showModal={showExportModal}
          closeModal={closeExportModal}
          selectedParticipantIds={selectedParticipantIds}
        />
      )}
      {showSendScreenerModal && (
        <SendScreenerModal
          openModal={showSendScreenerModal}
          closeModal={closeSendScreenerModal}
          selectedParticipantIds={selectedParticipantIds}
        />
      )}
      <Menu anchorEl={anchorEl} open={open} onClose={() => setAnchorEl(null)}>
        <MenuItem
          onClick={() => {
            setAnchorEl(null);
            openConsentDrawer("consent");
          }}
        >
          <ListItemText> Send Consent</ListItemText>
        </MenuItem>
        <MenuItem
          onClick={() => {
            setAnchorEl(null);
            openConsentDrawer("sunshine");
          }}
        >
          <ListItemText> Send Sunshine Form</ListItemText>
        </MenuItem>
        <MenuItem
          onClick={() => {
            setAnchorEl(null);
            setShowSendScreenerModal(true);
          }}
        >
          <ListItemText> Send Screener</ListItemText>
        </MenuItem>
        {/* <MenuItem
          onClick={() => {
            setAnchorEl(null);
            setShowExportModal(true);
          }}
        >
          <ListItemText> Export Data</ListItemText>
        </MenuItem> */}
      </Menu>
    </StyledHeader>
  );
};

export default RecordsHeader;
